import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import {
  inviteNewShipper,
  ShipperInvitationInput
} from '@/types/graphql/schemaTypes';

import deleteMutation from '@/graphql/mutations/shipper/Delete.gql';
import inviteNewShipperMutation from '@/graphql/mutations/shipper/Invite.gql';

class ShipperService extends BaseService {
  public deleteShipper(id: string) {
    return this.client.mutate({
      mutation: deleteMutation,
      variables: {
        id
      }
    });
  }

  public inviteNewShipperMutation(
    shipperInvitationArgs: ShipperInvitationInput,
    customerOrganizationId: string
  ): Promise<FetchResult<inviteNewShipper>> {
    return this.client.mutate({
      mutation: inviteNewShipperMutation,
      variables: {
        shipperInvitationArgs,
        customerOrganizationId
      }
    });
  }
}

export const shipperService = new ShipperService();
